import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { speakingSessionStore } from 'store';

export const RemoveSpeakingSessionRoom = () => {
  const sessionId = useIntParam('sessionId');
  const sessionRoomId = useIntParam('sessionRoomId');
  const { speakingSessionDetails } = ROUTING_PATHS;
  const [removeRoom, { isSuccess, error: removeError, isLoading: isConfirming, reset }] =
    speakingSessionStore.service.useRemoveSpeakingSessionRoomMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(removeError), [removeError]);

  const goToSpeakingSessionDetails = useCallback(() => {
    navigate(generatePath(speakingSessionDetails.absolutePath, { sessionId }));
  }, [navigate, speakingSessionDetails.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        message: 'Room removed successfully',
      });
      goToSpeakingSessionDetails();
      reset();
    }
  }, [goToSpeakingSessionDetails, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Remove room</Modal.Header>
        <Modal.Content>
          <ValidationErrors />
          <p>Are you sure you want to remove this room from this Speaking session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link to={generatePath(speakingSessionDetails.absolutePath, { sessionId })}>
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="red"
            onClick={() => {
              removeRoom({ speakingSessionId: sessionId, speakingSessionRoomId: sessionRoomId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Remove
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};
